<template>
  <span>
    <slot :on="on" :attrs="attrs" :formatted="inputModel">
      {{inputModel}}
    </slot>
  </span>
</template>

<script>

import { /*AsYouType,*/ parsePhoneNumber } from 'libphonenumber-js'

export default {
  props: {
    value: String
  },
  data: () => ({
  }),
  computed: {
    on() {
      return {
        input: (e) => this.inputModel = e
        // keydown: (e) => this.inputModel = new AsYouType().input(e.key),
      }
    },
    attrs() {
      return {
        value: this.inputModel
      }
    },
    inputModel: {
      get() {
        try {
          let pn = new parsePhoneNumber(this.value)
          return pn?.formatInternational()
        } catch (e) {
          return this.value
        }
      },
      set(v) {
        try {
          let pn = new parsePhoneNumber(v)
          this.$emit('input', pn?.number || '')
        } catch (e) {
          this.$emit('input', v)
        }
      }
    }
  },
  methods: {

  }
}
</script>